module.exports = __webpack_public_path__ + "img/Powered-by-Bionic-mobile.968297d1.svg";